<template>
    <div class="no-gutters">
        <!-- If behavior is dynamic -->
        <otif-select
            :id="'facet-' + facet.id"
            :values="dimensions"
            placeholder="Choose a filter"
            :multiple="facet.cardinality === 'MULTI'"
            v-model="selectedFacets"
            v-if="facet.behavior === 'DYNAMIC'">
        </otif-select>
        <!-- If behavior is static -->
        <form v-else>
            <ul>
                <li class="facet OTfacet" v-for="dimension in facet.dimensions" :key="dimension.id">
                    <div class="fieldContainer form-group OTformgroupsingle">
                        <input type="checkbox" class="OTcheckbox" :id="'facet-' + slugify(dimension.id)" :name="facet.id" :value="dimension.id" v-model="selectedFacets">
                        <label class="OTcheckbox" :for="'facet-' + slugify(dimension.id)">
                            <span class="OTicon-checkbox"></span> {{ dimension.label }} &nbsp;
                            <div class="OTchiclet float-right" v-if="showChicklet(dimension.id)">{{ getDimensionCount(dimension.id) }}</div>
                        </label>                        
                    </div>
                </li>
            </ul>
        </form>
        <ul v-if="facet.dimensions.length > 0 && facet.cardinality === 'MULTI'"><li>
            <a  href="#" class="clear-facets OTfacetClear" v-on:click.prevent="clearAll">Clear Filters</a>
            </li></ul>
        
        <div class="clear clearfix"></div>
    </div>
</template>
<script>

import {slugify} from '../../utils.js';

export default {
    props: ['facet', 'value'],
    data() {
        return {
            selectedFacets: this.setDefaultValue()
        }        
    },
    methods: {
        clearAll() {
            this.selectedFacets = [];
        },
        slugify(val) {
            return slugify(val);
        },
        showChicklet(dimensionId) {
            var dimension = this.$store.state.facets.facets[this.facet.id].dimensions.find(d => d.id === dimensionId);
            return dimension.count > 0;
        },
        getDimensionCount(dimensionId) {
            var dimension = this.$store.state.facets.facets[this.facet.id].dimensions.find(d => d.id === dimensionId);
            return dimension.count;
        },
        setDefaultValue() {            
            if(this.$store.state.facets.selectedFacets[this.facet.id]){
                this.selectedFacets = this.$store.state.facets.selectedFacets[this.facet.id]
                return this.$store.state.facets.selectedFacets[this.facet.id]
            } else {
                return this.value
            }
        }        
    },

    beforeDestroy() {
    },

    mounted() {
        
    },

    computed: {

        dimensions() {

            var dim = [];
    
            var facet = this.facet;

            facet.dimensions.forEach((dimension) => {
                dim.push({
                    value: '' + dimension.id,
                    label: dimension.label
                });
            });
                
            return dim;
        }
    },

    watch: {
        selectedFacets(newSelectedFacets) {
            
            this.$emit('input', {
                dimensions: this.selectedFacets
            });
        }
    }
}

</script>
